import React from 'react';
import { useChatContext } from 'stream-chat-react';

import { CloseOutlined, PlusOutlined } from '@ant-design/icons';

type Props = {
  isCreating?: boolean;
  onCreateChannel?: () => void;
  theme: string;
};

const MessagingChannelListHeader: React.FC<Props> = React.memo((props) => {
  const { onCreateChannel, theme, isCreating = false } = props;

  const { client } = useChatContext();

  const { id, name = 'Chat' } = client.user || {};

  return (
    <div className={`${theme} messaging__channel-list`}>
      <div className="messaging__channel-list__header">
        <div className={`${theme} messaging__channel-list__header__name`}>{name || id}</div>

        <button
          className={`${theme} messaging__channel-list__header__button`}
          onClick={onCreateChannel}
          title={isCreating ? 'Cancel' : 'New conversation'}
        >
          {isCreating ? (
            <CloseOutlined style={{ fontSize: 14 }} />
          ) : (
            <PlusOutlined style={{ fontSize: 16 }} />
          )}
        </button>
      </div>
    </div>
  );
});

export default React.memo(MessagingChannelListHeader);
